import { Icon } from "@/components/icons/Icon";
import { Tooltip } from "@/components/TooltipV2";
import { classNames } from "@/utils/classnames";
import { isAdminSuspended } from "@/utils/environment";
import { useRouteAndTeamInfo } from "@/utils/hooks/url/use-route-info";
import React from "react";

export const SuspendedIndicator: React.FC<{ className?: string }> = ({ className }) => {
  const { environment } = useRouteAndTeamInfo();
  const suspensionLabel = isAdminSuspended(environment) ? "Suspended by Chalk" : "Suspended";

  return (
    <Tooltip
      style={{ maxWidth: "100%" }}
      placement={"bottom-end"}
      content={
        isAdminSuspended(environment) ? (
          suspensionLabel
        ) : (
          <div>
            Suspended environments do not consume resources, but some dashboard components may not
            work.
          </div>
        )
      }
    >
      <div
        className={classNames(
          "flex items-center gap-1",
          "rounded-md px-2 py-1",
          "bg-yellow-50",
          "text-cds-sm text-yellow-700 font-normal select-none",
          className,
        )}
      >
        <div>{suspensionLabel}</div>
        <Icon name={"warning"} />
      </div>
    </Tooltip>
  );
};

export const SimpleSuspendedIndicator: React.FC<{ className?: string }> = ({ className }) => {
  return (
    <div
      className={classNames(
        "flex items-center rounded-md",
        "bg-yellow-50",
        "text-yellow-700 px-2 py-[2px]",
        className,
      )}
    >
      Suspended
    </div>
  );
};
